"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lab = require("@mui/lab");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../utils");
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
const Tabs = _ref => {
  var _ref2, _tabs$;
  let {
    activeTab,
    onTabChange,
    tabs,
    tabStyle,
    headerBorder = false
  } = _ref;
  const [selectedTab, setSelectedTab] = (0, _react.useState)((_ref2 = activeTab !== null && activeTab !== void 0 ? activeTab : (_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.id) !== null && _ref2 !== void 0 ? _ref2 : '');
  const theme = (0, _material.useTheme)();
  const {
    isMobile
  } = (0, _utils.useDeviceInfo)();
  const tabStyles = [{
    color: theme.palette.TwClrTxtSecondary,
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    minHeight: theme.spacing(4.5),
    padding: theme.spacing(1, 2),
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: theme.palette.TwClrBgHover
    },
    '&.Mui-selected': {
      color: theme.palette.TwClrTxtBrand
    },
    '&.MuiTab-labelIcon': {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row'
    },
    '& .MuiTab-iconWrapper': {
      fill: theme.palette.TwClrIcnSecondary,
      marginBottom: 0,
      marginRight: theme.spacing(1)
    },
    '&.Mui-selected .MuiTab-iconWrapper': {
      fill: theme.palette.TwClrIcnBrand
    }
  }, ...(Array.isArray(tabStyle) ? tabStyle : [tabStyle])];
  const tabHeaderProps = {
    borderBottom: headerBorder ? 1 : 0,
    borderColor: 'divider',
    margin: isMobile ? 0 : theme.spacing(0, 4)
  };
  const tabPanelStyles = {
    padding: 0
  };
  const setTab = tab => {
    if (onTabChange) {
      onTabChange(tab);
    } else {
      setSelectedTab(tab);
    }
  };
  (0, _react.useEffect)(() => {
    if (activeTab !== undefined) {
      setSelectedTab(activeTab);
    }
  }, [activeTab]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(_lab.TabContext, {
    value: selectedTab
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: tabHeaderProps
  }, /*#__PURE__*/_react.default.createElement(_lab.TabList, {
    onChange: (unused, value) => setTab(value),
    sx: {
      minHeight: theme.spacing(4.5)
    },
    TabIndicatorProps: {
      style: {
        background: theme.palette.TwClrBgBrand,
        height: '4px'
      }
    },
    variant: 'scrollable'
  }, tabs.map((tab, index) => /*#__PURE__*/_react.default.createElement(_material.Tab, {
    disabled: tab.disabled,
    icon: tab.icon ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: tab.icon
    }) : undefined,
    key: index,
    label: tab.label,
    sx: tabStyles,
    value: tab.id
  })))), tabs.map((tab, index) => /*#__PURE__*/_react.default.createElement(_lab.TabPanel, {
    key: index,
    sx: tabPanelStyles,
    value: tab.id
  }, tab.children))));
};
var _default = exports.default = Tabs;